/* FJK video hero: loads only the PC or the mobile film, keeps the button in step with the scene,
   pauses off-screen or on request, and shows the poster only when the visitor prefers reduced motion. */
(function () {
  function init(vh) {
    if (vh.dataset.ready) return;
    vh.dataset.ready = '1';
    var mq = window.matchMedia('(max-width: 760px)');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var vids = [vh.querySelector('.vh-pc'), vh.querySelector('.vh-mo')];
    var scenes = [];
    try { scenes = JSON.parse(vh.getAttribute('data-scenes') || '[]'); } catch (e) { scenes = []; }
    var btn = vh.querySelector('.vh-btn'), label = vh.querySelector('.vh-btn-label');
    var pauseBtn = vh.querySelector('.vh-pause'), iPause = pauseBtn.querySelector('.i-pause'), iPlay = pauseBtn.querySelector('.i-play');
    var cur = null, userPaused = reduce, visible = true, last = -1;

    function setIcon() {
      var p = !cur || cur.paused;
      iPause.hidden = p; iPlay.hidden = !p;
      var lang = document.documentElement.lang;
      var L = lang === 'en' ? ['Play video', 'Pause video'] : lang === 'ja' ? ['動画を再生', '動画を一時停止'] : lang === 'es' ? ['Reproducir video', 'Pausar video'] : ['영상 재생', '영상 일시정지'];
      pauseBtn.setAttribute('aria-label', p ? L[0] : L[1]);
    }
    function sync() {
      if (!cur || !scenes.length) return;
      var t = cur.currentTime || 0, idx = 0;
      for (var i = 0; i < scenes.length; i++) if (t >= scenes[i].t) idx = i;
      if (idx === last) return;
      last = idx;
      label.textContent = scenes[idx].label;
      if (scenes[idx].href) btn.setAttribute('href', scenes[idx].href);
    }
    function update() {
      if (!cur) return;
      if (userPaused || !visible || !vh.classList.contains('is-on')) { cur.pause(); }
      else {
        if (!cur.getAttribute('src') && cur.dataset.src) { cur.setAttribute('src', cur.dataset.src); cur.preload = 'auto'; }
        var p = cur.play();
        if (p && p.catch) p.catch(function () {});
      }
      setIcon();
    }
    function pick() {
      var next = mq.matches ? vids[1] : vids[0];
      if (next === cur) return;
      if (cur) cur.pause();
      cur = next; last = -1;
      sync(); update();
    }

    vids.forEach(function (v) {
      if (!v) return;
      v.addEventListener('timeupdate', function () { if (v === cur) sync(); });
      v.addEventListener('play', setIcon);
      v.addEventListener('pause', setIcon);
    });
    pauseBtn.addEventListener('click', function () { userPaused = !(cur && cur.paused); update(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { visible = es[0].isIntersecting; update(); }, { threshold: 0.2 }).observe(vh);
    }
    /* In a slider, play only while this slide is showing, and start the film over each time it comes back. */
    if ('MutationObserver' in window) {
      var wasOn = vh.classList.contains('is-on');
      new MutationObserver(function () {
        var on = vh.classList.contains('is-on');
        if (on && !wasOn && cur) { try { cur.currentTime = 0; } catch (e) {} last = -1; sync(); }
        wasOn = on; update();
      }).observe(vh, { attributes: true, attributeFilter: ['class'] });
    }
    if (mq.addEventListener) mq.addEventListener('change', pick); else if (mq.addListener) mq.addListener(pick);
    pick();
  }
  function scan(scope) { (scope || document).querySelectorAll('[data-fjk-vh]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
